export default "__VITE_ASSET__Cd5t849P__"